import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { simpleCopy } from '@/utils/deepCopy';
import { InputExcelInfosRepository } from '@/coreInfrastructureModule/Repositories/InputExcelInfosRepository';
import {
  AlterableHeaderInfo,
  InputFileType,
  SelectYearMonthPatternInHeader,
  SelectYearMonthPatternInlined,
} from '../pages/interfaces/LinkingInput';
import { InputNumberInput } from '../pages/interfaces/InputField';
import { SelectYearMonthPattern, UploadInputFileType } from '../pages/interfaces/UploadFile';
import { PutExcelInputInfoAdapter } from '../adapters/PutExcelInputInfoAdapter';
import { assertNever } from '@/coreDomainsModule/assertNever';

/**
 * 入力エクセルの読み込み情報を登録する
 */
export class RegisterExcelInputInfoUseCase {
  /**
   *  データを保存する
   * @param targetKeyName - 変更するキー名
   * @param registerKeyName - 登録するキー名
   * @param uploadInputFileType - ファイルタイプ
   * @param headerNumber - ヘッダー行番号
   * @param useFormatType - 年月情報の取得パターン
   * @param alternateHeaderInfos - 読み替え可能なヘッダー情報
   * @param inlinedYearMonthInfo - 年月情報の取得パターン（インライン）
   * @param inHeaderYearMonthInfo - 年月情報の取得パターン（ヘッダー）
   * @param adapter - アダプタ
   * @param repository - リポジトリ
   */
  public async Execute(
    targetKeyName: string,
    registerKeyName: string,
    uploadInputFileType: UploadInputFileType,
    headerNumber: InputNumberInput,
    useFormatType: SelectYearMonthPattern,
    alternateHeaderInfos: AlterableHeaderInfo[],
    inlinedYearMonthInfo: SelectYearMonthPatternInlined,
    inHeaderYearMonthInfo: SelectYearMonthPatternInHeader,
    adapter: PutExcelInputInfoAdapter,
    repository: InputExcelInfosRepository
  ): Promise<INetworkResult<undefined, IError>> {
    try {
      const registerData = simpleCopy(
        adapter.adapt(headerNumber, useFormatType, alternateHeaderInfos, inlinedYearMonthInfo, inHeaderYearMonthInfo)
      );
      let inputFileType: InputFileType;
      switch (uploadInputFileType) {
        case '在庫':
          inputFileType = 'Inventory';
          break;
        case '販売実績':
          inputFileType = 'SalesResults';
          break;
        case '入荷':
          inputFileType = 'Arrival';
          break;
        default:
          assertNever(uploadInputFileType);
          inputFileType = 'Inventory';
          break;
      }
      const response = await repository.put(targetKeyName, registerKeyName, inputFileType, registerData);
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      } else {
        return {
          // 基本的にはここには来ない
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }
}
